import { useState } from 'react';
import TreeView from '@mui/lab/TreeView';
import TreeItem from '@mui/lab/TreeItem';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import MonitorIcon from '@mui/icons-material/Monitor';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import WarningIcon from '@mui/icons-material/Warning';
import HelpIcon from '@mui/icons-material/Help';
import { useSelector } from 'react-redux';

const Nodos = () => {
  const nodes = useSelector((state) => state?.fuse?.monitoreo?.topologicNodes);
  const [enabled, setEnabled] = useState(true);

  const enabledButton = (clickEnabled) => {
    setEnabled(clickEnabled);
  };

  const setIcon = (state) => {
    if (state === 'verde') {
      return <CheckCircleIcon style={{ color: 'green' }} />;
    }
    if (state === 'amarillo') {
      return <WarningIcon style={{ color: 'orange' }} />;
    }
    if (state === 'rojo') {
      return <ErrorIcon style={{ color: 'red' }} />;
    }
    return <HelpIcon />;
  };

  return (
    <>
      <TreeView
        aria-label="file system navigator"
        defaultCollapseIcon={<ExpandMoreIcon />}
        defaultExpandIcon={<ChevronRightIcon />}
        sx={{ height: '65vh', flexGrow: 1, maxWidth: '95%', overflowY: 'auto' }}
      >
        {nodes.map((node, index) => (
          <TreeItem
            key={index}
            nodeId={index.toString()}
            label={node?.nodo}
            icon={setIcon(node?.estatus)}
            onClick={() => {}}
            style={{ padding: '10px 0px 10px 0px' }}
          />
        ))}
      </TreeView>
    </>
  );
};

export default Nodos;
